import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "今日爆料", to: "/breaking" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50 font-heading font-bold text-lg">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg text-foreground-950">黑吃瓜网</span>
              <span className="text-[11px] text-primary-700 mt-0.5">今日爆料 · 新瓜汇总</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive(link.to)
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/breaking"
              className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              搜爆料
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3" aria-label="移动端导航">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`py-3 px-2 rounded-md text-sm font-medium cursor-pointer ${
                  isActive(link.to) ? "text-primary-700" : "text-foreground-800"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/breaking"
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              去搜爆料
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}